import {useState,useCallback,useEffect} from 'react';

import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert';
import Dialog from '@base/Dialog';
import CartaoService from '@services/CartaoService';
import TextField from '@base/Inputs/Text';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { codigoCartaoMask } from '@helpers/MaskHelper'

export const DetalhamentoObjetosDialog = (props) => {
  const [cartao,setCartao] = useState("");
   const [detalhamento,setDetalhamento] = useState({});
   const [detalhamentoErro,setDetalhamentoErro] = useState("");


  const actions = () => {
    return (
      <>
       
      </>
    )
  }

  const carregarDados = useCallback(() => {

    if(cartao === ""){
      setDetalhamento({});
       setDetalhamentoErro("");
    }else if(cartao.length === 16){
      CartaoService.detalhamentoObjetos(props.objetoPostal, cartao).then(retorno => {
          setDetalhamentoErro("");
         setDetalhamento(retorno.data);

		  }).catch(err => {
        setDetalhamentoErro("Não conseguimos montar o detalhamento para o cartão informado.");
        setDetalhamento({});
      });
    }else{
        setDetalhamentoErro("");
        setDetalhamento({});
    }

		
	}, [cartao, props.objetoPostal]);
useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Dialog
        openDialog={props.open}
        title={props.title}
        closeDialog={props.close}
        actions={actions()}
        fullWidth={true}
        maxWidth={props.maxWidth ?? "sm"}
      >
        <Grid alignItems="center" container spacing={2}>
            <TextField  inputProps={{ maxLength: 16 }} autoFocus label="Código do Cartão" value={cartao} 
              onChange={(e) => setCartao(codigoCartaoMask(e.target.value))}
              onKeyDown={(e) => {
                if (e.key === 'Backspace' || e.key === 'Delete') {
                   setDetalhamento({});
                }
              }} />
            
            {detalhamentoErro ?  <><Alert severity="warning">{detalhamentoErro}</Alert></> : <></>} 
            
            {detalhamento.cartao ? 
            <Table style={{width:'100%'}}>
              
                <TableHead>

                  <TableRow>

                      <TableCell></TableCell>
                      <TableCell><span style={{fontWeight:'bold'}}>Objeto Atual</span></TableCell>
                      <TableCell><span style={{fontWeight:'bold'}}>Objeto Previsto</span></TableCell>

                  </TableRow>

                </TableHead>

                <TableBody>

                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>{detalhamento.objeto.numero}</TableCell>
                      <TableCell>{detalhamento.objetoEticket.numero}</TableCell>
                    </TableRow>

<TableRow>
                      <TableCell><span style={{fontWeight:'bold'}}>Recebimento</span></TableCell>
                      <TableCell>
                          {detalhamento.objeto.dataRecebimento  ? detalhamento.objeto.dataRecebimento : "--"}<br/>
                          {detalhamento.objeto.usuarioRecebimento}
                      </TableCell>
                      <TableCell>
                          {detalhamento.objetoEticket.dataRecebimento  ? detalhamento.objetoEticket.dataRecebimento : "--"}<br/>
                          {detalhamento.objetoEticket.usuarioRecebimento}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell><span style={{fontWeight:'bold'}}>Triagem</span></TableCell>
                      <TableCell>
                          {detalhamento.objeto.dataTriagem  ? detalhamento.objeto.dataTriagem : "--"}<br/>
                          {detalhamento.objeto.usuarioTriagem}
                      </TableCell>
                      <TableCell>
                          {detalhamento.objetoEticket.dataTriagem  ? detalhamento.objetoEticket.dataTriagem : "--"}<br/>
                          {detalhamento.objetoEticket.usuarioTriagem}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell><span style={{fontWeight:'bold'}}>Lançamento</span></TableCell>
                      <TableCell>

                          {detalhamento.objeto.dataLancamentoContagem  ? detalhamento.objeto.dataLancamentoContagem : "--"}<br/>
                          {detalhamento.objeto.usuarioLancamentoContagem}

                      </TableCell>
                      <TableCell>

                         {detalhamento.objetoEticket.dataLancamentoContagem  ? detalhamento.objetoEticket.dataLancamentoContagem : "--"}<br/>
                         {detalhamento.objetoEticket.usuarioLancamentoContagem}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell><span style={{fontWeight:'bold'}}>Digitalização</span></TableCell>
                      <TableCell>
                          {detalhamento.objeto.dataDigitalizacao ? detalhamento.objeto.dataDigitalizacao : "--" }<br/>
                          {detalhamento.objeto.usuarioDigitalizacao}<br/>
                           {detalhamento.objeto.estacaoDigitalizacao}
                      </TableCell>
                      <TableCell> {detalhamento.objetoEticket.dataDigitalizacao  ? detalhamento.objetoEticket.dataDigitalizacao : "--"}<br/>
                      {detalhamento.objetoEticket.usuarioDigitalizacao}<br/>
                      {detalhamento.objeto.estacaoDigitalizacao}
                      </TableCell>
                    </TableRow>

                </TableBody>

            </Table> : <></>}


            {props.detalhamento}

        </Grid>
      </Dialog>
    </>
  )
}

export default DetalhamentoObjetosDialog;
